import { useEffect, useState } from "react";
import { INavigationContainerProps } from "./Navigation.interfaces";
import NavigationView from "./Navigation.view";

export default function NavigationContainer(props: INavigationContainerProps) {
    const [showMenu, setShowMenu] = useState(false);
    const [showDemo, setShowDemo] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState<null | "products" | "solutions" | "aiBlock">(
        null
    );
    const [scroll, setScroll] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showDropdownTwo, setShowDropdownTwo] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", function () {
            if (window.scrollY > 0) {
                setScroll(true);
            } else {
                setScroll(false);
            }
        });
        return () => {
            if (screenWidth <= 768) {
                setActiveDropdown(null);
                setShowDemo(false);
            }
        };
    });

    const menuController = () => setShowMenu(!showMenu);
    const demoController = () => setShowDemo(!showDemo);
    const solutionController = () => {
        setActiveDropdown(activeDropdown === "solutions" ? null : "solutions");
    };
    const productController = () => {
        setActiveDropdown(activeDropdown === "products" ? null : "products");
    };
    const aiBlockHandler = () => {
        setActiveDropdown(activeDropdown === "aiBlock" ? null : "aiBlock");
    };
    const scrollController = () => setScroll(!scroll);
    const dropdownController = () => setShowDropdown(!showDropdown);
    const dropdownControllertwo = () => setShowDropdownTwo(!showDropdownTwo);
    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };
    return (
        <>
            <NavigationView
                menuController={menuController}
                demoController={demoController}
                solutionController={solutionController}
                productController={productController}
                showMenu={showMenu}
                showDemo={showDemo}
                showSolution={activeDropdown === "solutions"}
                showProducts={activeDropdown === "products"}
                scroll={scroll}
                scrollController={scrollController}
                showDropdown={showDropdown}
                dropdownController={dropdownController}
                scrollToTop={scrollToTop}
                showAiBlock={activeDropdown === "aiBlock"}
                aiBlockHandler={aiBlockHandler}
                scrollToBlockchainSection={props.scrollToBlockchainSection}
                scrollToOilRefinerySection={props.scrollToOilRefinerySection}
                scrollToPredictiveSection={props.scrollToPredictiveSection}
                scrollToHealthcareSection={props.scrollToHealthcareSection}
                showDropdownTwo={showDropdownTwo}
                dropdownControllertwo={dropdownControllertwo}
             

            />
        </>
    );
}
